module.exports = __webpack_public_path__ + "3e35b1ef229dd73986573511074297cd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/tree-top-s.png
// module id = 2792
// module chunks = 0